import {
  Button,
  Checkbox,
  Form,
  Input,
  Modal,
  Popconfirm,
  Switch,
  Tag,
  Upload,
} from "antd";
import CustomButton from "../../components/AccommodationData/CustomButton/CustomButton";
import TextArea from "antd/es/input/TextArea";
import { createMobileNotification } from "../../services/MobileNotificationService";
import { useEffect, useRef, useState } from "react";
import { Participant } from "../../models/Participant";
import { Toast } from "primereact/toast";
import {
  CloseCircleOutlined,
  DeleteOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { RcFile } from "antd/es/upload";
import { uploadFile } from "../../services/FileService";
import { Image } from "antd";
import { Editor } from "primereact/editor";

function PopUp(props: any) {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const toast = useRef<any>(null);
  const [photos, setPhotos] = useState<any[]>([]);
  const [allSelectedParticipant, setAllSelectedParticipant] = useState<any>([]);
  const [indicator, setIndicator] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredList, setFilteredList] = useState<any>([]);
  const [allSelect, setAllSelect] = useState<boolean>(false);
  const [appName, setAppName] = useState<string>("sdo");
  ///// PATH FOR IMAGES
  let serverUrl = process.env.REACT_APP_API_URL;
  let storageUrl = serverUrl + "files/storage/";
  const [HTMLtext, setHTMLText] = useState<any>("");

  useEffect(() => {
    const upgradeListParticipant = props?.participantList?.map(
      (ucesnik: any) => {
        let selectedId = props?.selectedParticipant?.map(
          (participant: any) => participant.id
        );
        if (selectedId?.includes(ucesnik.id)) {
          return { ...ucesnik, select: true };
        }
        return ucesnik;
      }
    );

    upgradeListParticipant.sort((a: any, b: any) => {
      if (a.select && !b.select) {
        return -1;
      }
      if (b.select && !a.select) {
        return 1;
      }
      return 0;
    });

    setAllSelectedParticipant(upgradeListParticipant);
  }, [props]);

  useEffect(() => {
    let upgradeListParticipant = [...allSelectedParticipant];
    upgradeListParticipant.sort((a: any, b: any) => {
      if (a.select && !b.select) {
        return -1;
      }
      if (b.select && !a.select) {
        return 1;
      }
      return 0;
    });

    setAllSelectedParticipant(upgradeListParticipant);
  }, [indicator]);

  const beforeUpload = (file: RcFile) => {
    console.log("File", file);
    const allowedTypes = ["image/jpeg", "image/png"];
    const isAllowedType = allowedTypes.includes(file.type);
    const isAllowedSize = file.size / 1024 / 1024 < 50;

    if (!isAllowedType) {
      toast?.current?.show({
        severity: "error",
        detail: "Dozvoljeni formati slika su JPEG i PNG!",
        life: 3000,
      });
    }

    if (!isAllowedSize) {
      toast?.current?.show({
        severity: "error",
        detail: "Slika ne sme biti veća od 50MB!",
        life: 3000,
      });
    }

    return isAllowedType && isAllowedSize;
  };

  ////// UPLOAD IMAGE
  const handleUpload = async (file: any) => {
    try {
      const response = await uploadFile(file.file);
      const uploadedPhotoWithBackend = response.data;

      setPhotos((prevPhotos) => [...prevPhotos, uploadedPhotoWithBackend]);

      toast?.current?.show({
        severity: "success",
        detail: "Slika je uspešno uploadovana!",
        life: 3000,
      });
    } catch (error) {
      console.error(error);
      toast?.current?.show({
        severity: "error",
        detail: "Došlo je do greške prilikom uploada slike.",
        life: 3000,
      });
    }
  };

  const onCheckFunction = (participantO: Participant) => {
    let copyallSelectedParticipant = [...allSelectedParticipant];
    let filter: any = copyallSelectedParticipant?.find(
      (participant: Participant) => participant?.id == participantO.id
    );
    filter.select = !filter.select;
    setAllSelectedParticipant(copyallSelectedParticipant);
    setIndicator(!indicator);
    ///
    let participantsSend = copyallSelectedParticipant
      ?.filter((participant: any) => participant.select === true)
      .map((par: Participant) => par.id);

    props.checkedParticipantFunc(participantsSend);
  };

  const preventDefault = (
    e: React.MouseEvent<HTMLElement>,
    participantO: any
  ) => {
    e.preventDefault();
    let copyallSelectedParticipant = [...allSelectedParticipant];
    let filter: any = copyallSelectedParticipant?.find(
      (participant: Participant) => participant?.id == participantO.id
    );
    filter.select = !filter.select;
    setAllSelectedParticipant(copyallSelectedParticipant);
    setIndicator(!indicator);
    ///
    let participantsSend = copyallSelectedParticipant
      ?.filter((participant: any) => participant.select === true)
      .map((par: Participant) => par.id);

    props.checkedParticipantFunc(participantsSend);
  };

  const onSearch = (e: any) => {
    setSearchValue(e.target.value);
  };

  useEffect(() => {
    if (searchValue) {
      return setFilteredList(
        allSelectedParticipant?.filter((item: any) => {
          let searchItem = `${item.firstName} ${item.lastName}`;
          return (
            searchItem.toUpperCase().indexOf(searchValue.toUpperCase()) !== -1
          );
        })
      );
    } else {
      return setFilteredList(allSelectedParticipant);
    }
  }, [searchValue]);

  const selectAll = () => {
    setAllSelect(!allSelect);

    if (!allSelect) {
      let participantsSend = allSelectedParticipant.map(
        (par: Participant) => par.id
      );

      props.checkedParticipantFunc(participantsSend);
    } else {
      props.checkedParticipantFunc([]);
    }
  };

  useEffect(() => {
    if (allSelect) {
      let copyPar = [...allSelectedParticipant];
      let newArr = copyPar.map((par: any) => {
        return { ...par, select: true };
      });

      setAllSelectedParticipant(newArr);
    } else {
      let copyPar = [...allSelectedParticipant];
      let newArr = copyPar.map((par: any) => {
        return { ...par, select: false };
      });

      setAllSelectedParticipant(newArr);
    }
  }, [allSelect]);

  const handleOk = () => {
    let participantsSend = allSelectedParticipant
      ?.filter((participant: any) => participant.select === true)
      .map((par: Participant) => par.id);

    let notification = {
      title: title,
      content: content,
      participantIds: participantsSend,
      seen: false,
      file: photos,
      HTMLcontent: `<html><body>${HTMLtext}</body></html>`,
      appName: appName,
    };

    createMobileNotification(notification).then((res) => {
      toast?.current?.show({
        severity: "success",
        detail: `Uspešno poslate notifikacije!`,
        life: 3000,
      });
      setTitle("");
      setContent("");
      props.closeModalFunc();
      setPhotos([]);
      setHTMLText("");
      setAllSelectedParticipant([]);
    });
  };

  const handleCancel = () => {
    props.closeModalFunc();
    setPhotos([]);
    setHTMLText("");
    setAllSelectedParticipant([]);
  };

  const deletePhoto = (image: any) => {
    let copyImage = [...photos];
    let newFilter = copyImage.filter((imageD: any) => imageD.id !== image.id);
    setPhotos(newFilter);
  };

  const onChange = (checked: boolean) => {
    console.log(`switch to ${checked}`);
    setAppName(checked ? "sdo" : "aida");
  };

  console.log("ap", appName);

  return (
    <>
      <Toast ref={toast} position={"top-right"} />
      <Modal
        title="Notifikacija"
        open={props.openModal}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <CustomButton
            danger={false}
            htmlType={"submit"}
            type={"primary"}
            key={1}
            function={() => {
              handleCancel();
            }}
            text={"Zatvori"}
          />,
          <CustomButton
            danger={false}
            htmlType={"submit"}
            type={"primary"}
            key={1}
            function={() => {
              handleOk();
            }}
            text={"Pošalji"}
          />,
        ]}
        className="pop-up-custom"
      >
        <div className="container-notification">
          <div className="left-column-n">
            <div className="header-line">
              <Checkbox onChange={selectAll}>
                Selektuj sve {`(${allSelectedParticipant.length})`}
              </Checkbox>

              <span>
                Selektovano{" "}
                {`(${
                  allSelectedParticipant.filter(
                    (par: any) => par.select == true
                  ).length
                })`}
              </span>
            </div>

            <Input
              type="text"
              placeholder="Pretražite"
              onChange={(e) => onSearch(e)}
            />

            <div className="list-selected-p">
              {searchValue.length < 1
                ? allSelectedParticipant?.map(
                    (participant: any | Participant) => {
                      return (
                        <div className="item-p">
                          <Checkbox
                            checked={participant?.select}
                            onChange={() => {
                              onCheckFunction(participant);
                            }}
                          >
                            {participant?.firstName} {participant?.lastName}
                          </Checkbox>
                        </div>
                      );
                    }
                  )
                : filteredList?.map((participant: any | Participant) => {
                    return (
                      <div className="item-p">
                        <Checkbox
                          checked={participant?.select}
                          onChange={() => {
                            onCheckFunction(participant);
                          }}
                        >
                          {participant?.firstName} {participant?.lastName}
                        </Checkbox>
                      </div>
                    );
                  })}
              {searchValue.length > 1 && filteredList.length == 0 && (
                <span>Nema rezultata.</span>
              )}
            </div>
          </div>
          <div className="right-column-n">
            <div className="box-p">
              {allSelectedParticipant
                ?.filter((par: any) => par?.select == true)
                .map((participant: any) => {
                  return (
                    <Tag
                      closable
                      onClose={(e) => {
                        preventDefault(e, participant);
                      }}
                      style={{ marginBottom: "8px" }}
                    >
                      {participant?.firstName} {participant?.lastName}
                    </Tag>
                  );
                })}
            </div>

            <Switch
              checkedChildren="sdo"
              unCheckedChildren="aida"
              defaultChecked
              onChange={onChange}
              style={{ marginTop: "10px" }}
            />

            <Input
              placeholder="Naslov"
              style={{ margin: "10px 0px" }}
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />

            <Input
              value={content}
              placeholder="Tekst notifikacije"
              onChange={(e) => {
                setContent(e.target.value);
              }}
              style={{ marginBottom: "10px" }}
            />

            <Editor
              value={HTMLtext}
              onTextChange={(e) => setHTMLText(e.htmlValue)}
              style={{ height: "320px" }}
              placeholder="Sadrzaj notifikacije..."
            />

            <div className="second-column-rt">
              <Form.Item label="Dodaj sliku:">
                <div className="images-for-roomType">
                  <Upload
                    multiple
                    beforeUpload={beforeUpload}
                    accept="image/*"
                    customRequest={(file) => {
                      handleUpload(file);
                    }}
                    action=""
                    listType="picture"
                    className="upload"
                    showUploadList={false}
                  >
                    <Button className="button-upload" icon={<UploadOutlined />}>
                      Click to Upload
                    </Button>
                  </Upload>
                  <Image.PreviewGroup>
                    <div className="all-img-prev">
                      {photos.length > 0 &&
                        photos?.map((image: any, i: number) => {
                          let parts = image?.name?.split("-");
                          let result = {
                            firstFive: parts?.pop()?.substring(0, 7),
                            lastFour: image?.name?.slice(-4),
                          };

                          return (
                            <div className="upload-image-div" key={i}>
                              <div className="image-header-u">
                                <Image src={`${storageUrl}${image.id}`} />
                                <p>{`${result.firstFive}... ${result.lastFour}`}</p>
                              </div>

                              <div>
                                <Popconfirm
                                  title="Brisanje slike?"
                                  description="Da li ste sigurni da želite da izbrišete sliku?"
                                  onConfirm={() => {
                                    deletePhoto(image);
                                  }}
                                  onCancel={() => {}}
                                  okText="Da"
                                  cancelText="Ne"
                                >
                                  <DeleteOutlined
                                    style={{ cursor: "pointer" }}
                                  />
                                </Popconfirm>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </Image.PreviewGroup>
                </div>
              </Form.Item>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default PopUp;
